export enum SP3InputType {
  Internal = 0,
  FirstExpander = 1,
  LastExpander = 8,
  Wireless = 9,
  InternalATZ = 10, // tik vidiniams įėjimams. Visi kiti naudoja hwType tokį, koks yra šeimininko.
  Keypad = 11,
  FireSensor = 12,
}
